/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { services } from '@broadleaf/admin-components';

import ColorPaletteColumn from './ColorPaletteColumn';
import { BooleanToggleColumn, RowValueLinkColumn } from 'app/common/components';
import { AuroraLookupColumn } from 'app/form/named-components/column-types/LookupColumn';

const { ComponentRegistrar } = services;

ComponentRegistrar.registerColumnComponent('COLOR_PALETTE', ColorPaletteColumn);
ComponentRegistrar.registerColumnComponent(
  'BOOLEAN_TOGGLE_ROW',
  BooleanToggleColumn
);
ComponentRegistrar.registerColumnComponent(
  'ROW_VALUE_LINK',
  RowValueLinkColumn
);
ComponentRegistrar.registerColumnComponent('LOOKUP', AuroraLookupColumn);
